export interface ProgrammationIAItem {
  id: number;
  title: string;
  category: string;
  description: string;
  aiSuggestion: string;
  kpiScore: number;
  imageUrl?: string;
  isCompleted?: boolean;
  inKnowledgeBase?: boolean;
  scoreDany?: number;
  scoreYannick?: number;
  scoreFrancois?: number;
  visionDany?: string;
  visionYannick?: string;
  visionFrancois?: string;
  isInRevision?: boolean;
}

const allProgrammationIAData: ProgrammationIAItem[] = [
  {
    id: 1,
    title: "Vision & Ambition",
    category: "Stratégie",
    description: "IA = copilote de décision. Passer de 300k à 600k en 12 mois avec la même équipe. 100% des clients font plus de cash grâce à l'IA.",
    aiSuggestion: "Découvrez notre vision : l'IA comme copilote de décision pour transformer votre business.",
    kpiScore: 95,
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "Notre vision, c'est claire : l'IA comme copilote de décision. Le chatbot propose, l'humain dispose. On veut passer de 300k à 600k en 12 mois avec la même équipe. 100% des clients font plus de cash grâce à l'IA. C'est notre promesse.",
    visionYannick: "La vision est ambitieuse mais réaliste. 300k à 600k, c'est du doublement. Mais avec l'IA comme copilote, c'est possible. Les clients voient la valeur, ils paient pour ça.",
    visionFrancois: "Techniquement, la vision est structurée. IA comme copilote, pas comme remplacement. L'humain décide toujours. C'est la bonne approche.",
    imageUrl: "https://images.unsplash.com/photo-1454165205744-3b78555e5572?w=800&q=80"
  },
  {
    id: 2,
    title: "Cadre PROGRAM-IA",
    category: "Framework",
    description: "Cahier 1-page signé → POC ≤ 48h → Overview in-app obligatoire. Norme obligatoire pour tous les projets.",
    aiSuggestion: "Suivez le cadre PROGRAM-IA pour garantir la qualité et la rapidité de livraison de vos projets.",
    kpiScore: 92,
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "Le cadre PROGRAM-IA, c'est notre norme. Cahier 1-page signé, POC en 48h max, Overview in-app obligatoire. Pas de dev sans 1-page. C'est clair, c'est structuré, ça fonctionne.",
    visionYannick: "Le cadre PROGRAM-IA, c'est rassurant pour les clients. Ils voient qu'on a un processus clair, structuré. C'est professionnel.",
    visionFrancois: "Techniquement, le cadre assure la qualité. Cahier signé, POC rapide, Overview visible. C'est l'excellence opérationnelle.",
    imageUrl: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&q=80"
  },
  {
    id: 3,
    title: "Concept A-Z BZ Prog",
    category: "Processus",
    description: "Cycle complet : besoins → cahier → maquette → roadmap → contrat → suivi → mise à jour annuelle. Norme obligatoire tous projets.",
    aiSuggestion: "Découvrez notre cycle complet de gestion de projet de A à Z.",
    kpiScore: 90,
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "Le Concept A-Z, c'est notre cycle complet. Besoins, cahier, maquette, roadmap, contrat, suivi, mise à jour annuelle. C'est complet, c'est professionnel, c'est BZ.",
    visionYannick: "Le Concept A-Z, c'est rassurant. Le client voit qu'on a un processus complet, structuré. C'est professionnel.",
    visionFrancois: "Techniquement, le Concept A-Z assure la traçabilité complète. Chaque étape est documentée, chaque décision est justifiée.",
    imageUrl: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800&q=80"
  },
  {
    id: 14,
    title: "Gouvernance Programmation & IA",
    category: "Gouvernance",
    description: "Le cadre complet : 10 axes de maturité, gouvernance, roadmap 2026, RACI et rituels.",
    aiSuggestion: "Consultez la gouvernance Programmation & IA pour structurer l'excellence du département.",
    kpiScore: 85,
    imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80",
    isCompleted: false,
    scoreDany: 0,
    scoreYannick: 0,
    scoreFrancois: 0,
    visionDany: "",
    visionYannick: "",
    visionFrancois: ""
  },
  {
    id: 15,
    title: "Gestion de réunion — Direction programmation",
    category: "Gouvernance",
    description: "Gestion complète des réunions de la direction programmation : liste, historique, participants, ordre du jour, notes, décisions, actions et résumés.",
    aiSuggestion: "Utilisez cette carte pour créer, documenter et suivre toutes les réunions de la direction programmation (Eric Durand, Guillaume Cloutier, Marc-Antoine Caron).",
    kpiScore: 90,
    imageUrl: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&q=80",
    isCompleted: false,
    scoreDany: 0,
    scoreYannick: 0,
    scoreFrancois: 0,
    visionDany: "",
    visionYannick: "",
    visionFrancois: ""
  },
  {
    id: 16,
    title: "Gouvernance OpenClaw",
    category: "Gouvernance",
    description: "Cadre de gouvernance pour l’implantation d’OpenClaw chez BZ : segmentation réseau, deny by default, accès granulaires, anonymisation, chiffrement, ownership clair et documentation continue.",
    aiSuggestion: "Consultez le cadre de gouvernance OpenClaw pour implanter les agents BZ dans un environnement contrôlé, segmenté et traçable.",
    kpiScore: 92,
    imageUrl: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80",
    isCompleted: false,
    scoreDany: 0,
    scoreYannick: 0,
    scoreFrancois: 0,
    visionDany: "",
    visionYannick: "",
    visionFrancois: ""
  },
  {
    id: 17,
    title: "Machine IA",
    category: "Infrastructure",
    description: "Comparatif structuré de 3 scénarios de machines dédiées à l’IA (5k, 10k, 15k CAD) avec VRAM, compatibilité logicielle, modèles LLM, évolutivité, ECC et références.",
    aiSuggestion: "Consultez cette carte pour orienter un achat de machine IA selon le budget, la VRAM, les modèles visés et la stratégie d’évolution.",
    kpiScore: 87,
    imageUrl: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&q=80",
    isCompleted: false,
    scoreDany: 0,
    scoreYannick: 0,
    scoreFrancois: 0,
    visionDany: "",
    visionYannick: "",
    visionFrancois: ""
  },
  {
    id: 5,
    title: "POC 48h - Règle d'Or",
    category: "Processus",
    description: "Mock data, 5 écrans, Go/No-Go. POC en ≤48h sur 95% des projets. Script démo obligatoire.",
    aiSuggestion: "Respectez la règle POC 48h pour valider rapidement vos concepts avant développement complet.",
    kpiScore: 91,
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "La règle POC 48h, c'est notre règle d'or. Mock data, 5 écrans, Go/No-Go. Si on dépasse 48h, on re-cadre. C'est clair, c'est rapide, ça fonctionne.",
    visionYannick: "Le POC 48h, c'est impressionnant pour les clients. Ils voient quelque chose de concret rapidement. C'est rassurant.",
    visionFrancois: "Techniquement, le POC 48h valide rapidement les concepts. Mock data, 5 écrans, décision Go/No-Go. C'est efficace.",
    imageUrl: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&q=80"
  },
  {
    id: 6,
    title: "Overview In-App",
    category: "Documentation",
    description: "ROI/KPI, Sécurité NIST-style, IA/Éthique, README, Roadmap. Obligatoire dans chaque application. 100% apps.",
    aiSuggestion: "Intégrez l'Overview in-app dans toutes vos applications pour transparence et documentation complète.",
    kpiScore: 93,
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "L'Overview in-app, c'est obligatoire. ROI/KPI, Sécurité, IA/Éthique, README, Roadmap. Tout est visible, tout est documenté. C'est la transparence radicale.",
    visionYannick: "L'Overview in-app, c'est rassurant pour les clients. Ils voient tout : ROI, KPI, sécurité, roadmap. C'est transparent, c'est professionnel.",
    visionFrancois: "Techniquement, l'Overview in-app assure la documentation complète. ROI, KPI, sécurité, éthique, tout est documenté et visible.",
    imageUrl: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&q=80"
  },
  {
    id: 7,
    title: "Chatbot AI - Vision",
    category: "IA",
    description: "Un bot par app/section, 100% contextualisé. Modes ASK, DO, LEARN, ESCALATE. CSAT bot ≥4/5.",
    aiSuggestion: "Implémentez le chatbot standard dans vos applications pour assistance intelligente et contextualisée.",
    kpiScore: 89,
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 4,
    visionDany: "Le chatbot AI, c'est notre vision. Un bot par app, 100% contextualisé. ASK, DO, LEARN, ESCALATE. C'est l'IA comme copilote. C'est puissant.",
    visionYannick: "Le chatbot AI, c'est impressionnant pour les clients. Ils ont une assistance intelligente, contextualisée. C'est moderne, c'est efficace.",
    visionFrancois: "Techniquement, le chatbot standard assure l'assistance intelligente. Contextualisé, modes multiples, escalade. C'est professionnel.",
    imageUrl: "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?w=800&q=80"
  },
  {
    id: 8,
    title: "CodeHub ERP",
    category: "Outil",
    description: "Le cœur et les poumons du département. Excellence obligatoire. Zéro faille vision/temps/docs. Amélioration continue standard.",
    aiSuggestion: "Utilisez CodeHub comme ERP de votre département pour gestion complète et transparence.",
    kpiScore: 94,
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 5,
    visionDany: "CodeHub, c'est le cœur et les poumons du département. C'est notre ERP. Excellence obligatoire. Zéro faille. Vision, temps, docs, tout est là. C'est notre fierté.",
    visionYannick: "CodeHub, c'est impressionnant. Le client voit tout : vision, temps, docs. C'est transparent, c'est professionnel.",
    visionFrancois: "Techniquement, CodeHub est l'ERP complet. Gestion de projets, temps, documentation, transparence. C'est l'excellence.",
    imageUrl: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=800&q=80"
  },
  {
    id: 9,
    title: "AI + HUMAN BOOM",
    category: "Philosophie",
    description: "L'IA conseille; l'humain décide. ≥80% actions validées. Mantra affiché partout.",
    aiSuggestion: "Adoptez la philosophie AI + HUMAN : l'IA comme copilote, l'humain comme décideur.",
    kpiScore: 87,
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 4,
    visionDany: "AI + HUMAN BOOM, c'est notre mantra. L'IA conseille, l'humain décide. ≥80% actions validées. C'est affiché partout. C'est notre philosophie.",
    visionYannick: "AI + HUMAN, c'est rassurant. Les clients voient qu'on utilise l'IA intelligemment, que l'humain reste au centre. C'est moderne et responsable.",
    visionFrancois: "Techniquement, AI + HUMAN assure l'équilibre. IA comme copilote, humain comme décideur. C'est la bonne approche.",
    imageUrl: "https://images.unsplash.com/photo-1555255707-c07966088b7b?w=800&q=80"
  },
  {
    id: 10,
    title: "Positionnement - 100% Clients",
    category: "Stratégie",
    description: "100% des clients font plus de cash grâce à l'IA. Promesse officielle. % mandats avec ROI mesurable.",
    aiSuggestion: "Adoptez le positionnement : 100% des clients font plus de cash grâce à l'IA.",
    kpiScore: 90,
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "Notre positionnement, c'est clair : 100% des clients font plus de cash grâce à l'IA. C'est notre promesse officielle. C'est audacieux, c'est vrai.",
    visionYannick: "Le positionnement 100% clients, c'est puissant. C'est une promesse claire, mesurable. Les clients voient la valeur, ils paient pour ça.",
    visionFrancois: "Techniquement, le positionnement est basé sur ROI mesurable. 100% clients font plus de cash. C'est documenté, c'est vrai.",
    imageUrl: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&q=80"
  },
  {
    id: 11,
    title: "Cadres Référentiels",
    category: "Standards",
    description: "ISO/IEC 42001 (Gouvernance IA), NIST AI RMF 1.0 (Risque IA), NIST SSDF + OWASP SAMM (SDLC Sécurisé), ISO/IEC 25010 (Qualité Produit).",
    aiSuggestion: "Appliquez les cadres référentiels pour garantir qualité, sécurité et conformité dans vos projets.",
    kpiScore: 88,
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "Les cadres référentiels, c'est notre excellence. ISO/IEC 42001, NIST AI RMF, NIST SSDF, ISO/IEC 25010. On suit les standards internationaux. C'est professionnel.",
    visionYannick: "Les cadres référentiels, c'est rassurant pour les clients. Ils voient qu'on suit les standards internationaux. C'est professionnel.",
    visionFrancois: "Techniquement, les cadres référentiels assurent la qualité, la sécurité, la conformité. Standards internationaux reconnus.",
    imageUrl: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?w=800&q=80"
  },
  {
    id: 12,
    title: "Transparence Radicale",
    category: "Valeur",
    description: "Client d'abord, CodeHub visible et à jour. Notre code = leur application. Visibilité 100%. Valeur BZ: transparence radicale.",
    aiSuggestion: "Adoptez la transparence radicale : CodeHub visible, code accessible, documentation à jour.",
    kpiScore: 92,
    isCompleted: true,
    scoreDany: 5,
    scoreYannick: 5,
    scoreFrancois: 4,
    visionDany: "La transparence radicale, c'est notre valeur. Client d'abord, CodeHub visible, code accessible. Notre code = leur application. C'est la confiance.",
    visionYannick: "La transparence radicale, c'est un différenciateur. Les clients voient tout, ils font confiance. C'est puissant.",
    visionFrancois: "Techniquement, la transparence radicale assure la confiance. CodeHub visible, code accessible, documentation à jour.",
    imageUrl: "https://images.unsplash.com/photo-1496307042754-b4aa456c4a2d?w=800&q=80"
  },
  {
    id: 13,
    title: "ARIA",
    category: "Produit transverse",
    description: "Moteur d'intelligence contextuelle de BZ. Permet à un humain non-technique de dialoguer avec les données de l'entreprise en langage naturel, tout en conservant un contrôle humain total.",
    aiSuggestion: "ARIA est le moteur d'intelligence contextuelle qui transforme l'accès aux données en conversation naturelle.",
    kpiScore: 85,
    isCompleted: true,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 4,
    visionDany: "ARIA, c'est notre moteur d'intelligence contextuelle. L'IA ne décide jamais, elle propose. L'humain reste maître en tout temps. C'est un produit transverse, module premium PRIsME.",
    visionYannick: "ARIA, c'est puissant pour les clients. Ils dialoguent avec leurs données en langage naturel, sans dépendre d'un programmeur. C'est l'autonomie totale.",
    visionFrancois: "Techniquement, ARIA structure l'accès aux données par gouvernance IA, pas par magie. Audit trail complet, validation humaine obligatoire. C'est professionnel."
  },
  {
    id: 18,
    title: "IA Agentique",
    category: "Gouvernance",
    description: "Cadre BZ complet pour comprendre, encadrer et déployer des agents IA en production. Architecture, niveaux d'autonomie L0-L5, RACI, sécurité, cas d'usage et roadmap.",
    aiSuggestion: "Structurez votre gouvernance IA Agentique avec le cadre BZ : architecture, autonomie, RACI et roadmap d'implantation.",
    kpiScore: 90,
    imageUrl: "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=800&q=80",
    isCompleted: false,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "L'IA Agentique c'est le prochain niveau. Des agents qui planifient, exécutent et s'ajustent. Mais sans gouvernance, c'est un risque. Le cadre BZ définit qui décide, qui exécute, qui valide. PRIsME est au centre.",
    visionYannick: "Les clients veulent des agents IA mais ont peur de perdre le contrôle. Le cadre IA Agentique de BZ leur montre qu'on peut déployer de façon structurée, mesurée et sécurisée.",
    visionFrancois: "Techniquement, les agents IA nécessitent une architecture solide : LLM local, RAG, orchestrateur, audit logs. Le cadre technique BZ couvre tout ça avec OpenClaw comme orchestrateur central."
  },
  {
    id: 19,
    title: "Gouvernance Agent IA",
    category: "Gouvernance",
    description: "Cadre officiel de gouvernance pour les agents IA chez BZ : principes fondateurs, cycle de vie, sécurité NIST, RACI, standards minimaux, maturité et roadmap de déploiement.",
    aiSuggestion: "Consultez le cadre de gouvernance Agent IA pour structurer, sécuriser et mesurer l'intégration des agents IA dans l'écosystème BZ.",
    kpiScore: 94,
    imageUrl: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80",
    isCompleted: false,
    scoreDany: 0,
    scoreYannick: 0,
    scoreFrancois: 0,
    visionDany: "",
    visionYannick: "",
    visionFrancois: ""
  },
  {
    id: 20,
    title: "Gouvernance Agentic AI",
    category: "Gouvernance",
    description:
      "Cadre de référence premium pour agents capables d'agir : identité, moindre privilège, RAG gouverné, orchestration, RACI, maturité 1–5, architecture de référence et rituels de pilotage — human-in-control et deny-by-default.",
    aiSuggestion:
      "Utilisez cette carte pour cadrer l'adoption des agents IA (outils, données, autonomie) avec un langage partagé direction, TI, sécurité et métier.",
    kpiScore: 96,
    imageUrl: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800&q=80",
    isCompleted: false,
    inKnowledgeBase: true,
    scoreDany: 0,
    scoreYannick: 0,
    scoreFrancois: 0,
    visionDany: "",
    visionYannick: "",
    visionFrancois: ""
  },
  {
    id: 21,
    title: "Gouvernance des comptes AI & modèle OAuth Agentic (AIKUB)",
    category: "Gouvernance",
    description: "Standard PRIsME Master pour formaliser le modèle 1 agent = 1 humain = 1 compte OpenAI OAuth, avec ownership clair, coût fixe prévisible, BotOps central et scaling horizontal.",
    aiSuggestion: "Cadrez la gouvernance OAuth agentique avec un standard Master simple, exécutable et orienté ownership, coûts fixes et BotOps.",
    kpiScore: 89,
    imageUrl: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80",
    isCompleted: false,
    inKnowledgeBase: true,
    isInRevision: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "Le vrai gain du modèle OAuth agentique, c'est la simplicité. Un humain, un agent, un compte. Ownership clair, coût fixe, moins de friction, plus de productivité.",
    visionYannick: "Pour qu'un modèle devienne scalable commercialement, il faut qu'il soit simple à expliquer et à opérer. Cette carte rend le cadre crédible et lisible.",
    visionFrancois: "Techniquement, ce modèle réduit le bruit d'orchestration multi-provider. On gagne en lisibilité d'architecture, en gouvernance des accès et en prévisibilité d'exploitation."
  },
  {
    id: 22,
    title: "Tiers logiciels agentiques",
    category: "Gouvernance",
    description: "Classification PRIsME proposée des logiciels agentiques : agent applicatif, agent workflow, agent opérateur desktop et Agent OS / runtime comme OpenClaw. Ce n'est pas encore une norme officielle.",
    aiSuggestion: "Utilisez cette carte pour expliquer clairement les différences entre copilotes applicatifs, workflows, computer-use agents et Agent OS, avec exemples produits et cas d'usage.",
    kpiScore: 91,
    imageUrl: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80",
    isCompleted: false,
    inKnowledgeBase: true,
    isInRevision: true,
    scoreDany: 5,
    scoreYannick: 4,
    scoreFrancois: 5,
    visionDany: "Cette grille aide à nommer ce qu'on voit sur le marché : un copilote dans une app n'est pas un Agent OS. OpenClaw est dans la couche la plus haute parce qu'il orchestre les agents, les outils, la mémoire et les canaux.",
    visionYannick: "Commercialement, c'est utile : on peut expliquer au client pourquoi un simple copilote ne livre pas la même valeur qu'une couche d'orchestration agentique complète.",
    visionFrancois: "Techniquement, la différence clé est la portée d'action : app locale, workflow multi-apps, contrôle desktop ou runtime central avec permissions, logs, sous-agents et gouvernance."
  },
  {
    id: 23,
    title: "Plan d'action 2026 virage Agentic AI client BZ",
    category: "Gouvernance",
    description: "Plan d'action 2026 pour accompagner le virage Agentic AI chez les clients BZ : vision, valeur client, maîtrise BZ, matrice RACI et plan opérationnel.",
    aiSuggestion: "Consultez le plan d'action 2026 : vue d'ensemble client/BZ, matrice RACI par composante et plan opérationnel.",
    kpiScore: 95,
    imageUrl: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=800&q=80",
    isCompleted: false,
    inKnowledgeBase: true,
    scoreDany: 5,
    scoreYannick: 0,
    scoreFrancois: 0,
    visionDany: "L'IA redéfinit déjà les règles du jeu. Notre ambition n'est pas de suivre cette transformation, mais de la diriger. Nous voulons faire de BZ une organisation augmentée par l'IA, où chaque processus, chaque décision et chaque service bénéficie de l'intelligence artificielle. En appliquant à nous-mêmes les meilleures pratiques que nous recommandons à nos clients, nous devenons la preuve vivante de ce qu'il est possible d'accomplir.",
    visionYannick: "",
    visionFrancois: ""
  },
  {
    id: 25,
    title: "Programmation mobile",
    category: "Développement mobile",
    description: "Capacité BZ pour publier et gouverner des applications Android et Apple : comptes développeur, accès, abonnements, signatures, conformité des boutiques et cycle de mise en production.",
    aiSuggestion: "Centralisez la gouvernance mobile : propriétaires des comptes, rôles nominatifs, échéances, certificats, validations et traçabilité des publications.",
    kpiScore: 82,
    imageUrl: "https://images.unsplash.com/photo-1607252650355-f7fd0460ccdb?w=800&q=80",
    isCompleted: false,
    inKnowledgeBase: true,
    scoreDany: 0,
    scoreYannick: 0,
    scoreFrancois: 0,
    visionDany: "",
    visionYannick: "",
    visionFrancois: ""
  },
];

export const AGENTIC_IA_ITEM_IDS = [16, 18, 19, 20, 21, 22, 23] as const;

export const agenticIAData = allProgrammationIAData.filter((item) =>
  AGENTIC_IA_ITEM_IDS.includes(item.id as (typeof AGENTIC_IA_ITEM_IDS)[number]),
);

export const programmationIAData = allProgrammationIAData.filter((item) =>
  !AGENTIC_IA_ITEM_IDS.includes(item.id as (typeof AGENTIC_IA_ITEM_IDS)[number]),
);




